import React from "react";
import { observer } from "mobx-react";
import { AnalyticsDashboardTemplate } from "themes/administration/analytics/pages";
import { AnalyticsDashboardViewStore } from "administration/analytics/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new AnalyticsDashboardViewStore(rootStore, componentProps),
    "analyticsDashboardViewStore"
)
@observer
class AnalyticsDashboard extends React.Component {
    render() {
        return <AnalyticsDashboardTemplate {...this.props} />;
    }
}

export default AnalyticsDashboard;
